import TextBlock from '@/components/atoms/text-block/text-block';
import StudentSuccess from '@/components/molecules/de-uni/student-success/student-success';
import IStudentSuccess from '@/models/viewModels/IStudentSuccess';
import IRichText from '@into-discovery/browsewebshared/src/models/viewModels/base/IRichText';
import React from 'react';
import styles from './brand-intro.module.scss';

type Props = {
  brandIntro: IRichText;
  brandName: string;
  metrics: IStudentSuccess[];
};

export default function BrandLandingIntro({ brandIntro, brandName, metrics = null }: Props) {
  return (
    <section id="brand-intro" className={`mt-3 d-flex align-items-end ${styles.brand_intro}`}>
      <div className="row">
        <div className="col">
          <TextBlock titleSize={2} title={`Why ${brandName}?`} text={brandIntro} />
        </div>
        {metrics && metrics?.every((e) => e.value) && (
          <div className="col-lg-4">
            <StudentSuccess metrics={metrics} />
          </div>
        )}
      </div>
    </section>
  );
}
